'use strict';

angular.module('TurneroApp').component('coTurnohistorial', {
	bindings: {
		idTurno: '<'
	},
    controller: [
        'turnosService',
        '$scope',
        'utilsService',
        function (turnosService, $scope, utilsService) {
            var ctrl = this;
            ctrl.mostrarFiltro = true;
            ctrl.atencionEnCursoConsulta = true;

            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.filter = false;

            ctrl.$onChanges = function () {
            	if (ctrl.idTurno) {
            		ctrl.query.id_turno = ctrl.idTurno;
            		ctrl.grillaReload();
            	}
            	
            };

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };
			
            ctrl.grillaReload = function () {
                utilsService.swalTitle('Cargando información', 'info')
                turnosService.Get_Estado_Historial({
                    'filtro.id_turno': ctrl.query.id_turno,
                    'filtro.nro_Pagina': ctrl.query.page,
                    'filtro.tam_Pagina': ctrl.query.limit

                }).$promise.then(function (data) {
                    ctrl.historial_Estado = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                    ctrl.TooltipDynamic();
                    swal.close();
                }).catch(function (error) {
                    if (ctrl.query.id_turno != "")
                        utilsService.errores(error);
                });
            }

            ctrl.TooltipDynamic = function () {
                for (var i = 0; i < ctrl.historial_Estado.length; i++) {
                    if (ctrl.historial_Estado[i].Destino_Derivacion !== '' && ctrl.historial_Estado[i].Destino_Derivacion !== null) {
                        var startCut = ctrl.historial_Estado[i].Destino_Derivacion.length - 3;
                        var sub_Derivacion = ctrl.historial_Estado[i].Destino_Derivacion.substring(startCut);
                        switch (sub_Derivacion) {
                            case "(P)":
                                ctrl.historial_Estado[i].stringDerivacion = "(P): Puesto";
                                break;
                            case "(G)":
                                ctrl.historial_Estado[i].stringDerivacion = "(G): Grupo";
                                break;
                            case "(A)":
                                ctrl.historial_Estado[i].stringDerivacion = "(A): Agenda";
                                break;
                            case "(T)":
                                ctrl.historial_Estado[i].stringDerivacion = "(T): Trámite";
                                break;
                            default:
                                ctrl.historial_Estado[i].stringDerivacion = "";
                        }
                    }
                }
            }
        }
    ],
    template: require('./turnoHistorial.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnoHistorialComponent.js